import AiOutlineClose from '../icons/AiOutlineClose';
import { func } from 'prop-types';
import { CartContext } from './context/CartContext';
import React, { useContext } from 'react';
import '../styles/CartDiscountCodeList.css';

const CartDiscountCodeList = ({ onRemoveDiscountCodeFailure, onRemoveDiscountCodeSuccess }) => {
    const { checkoutData, removeDiscountCode } = useContext(CartContext);

    const handleDiscountCodeRemoval = (discountCode) => async () => {
        try {
            const result = removeDiscountCode(discountCode.code);
            if (result.success) {
                onRemoveDiscountCodeSuccess();
            } else {
                onRemoveDiscountCodeFailure(result.error);
            }
        } catch (e) {
            onRemoveDiscountCodeFailure(e.message);
        }
    };

    return <div
        className={'cart-discount-code-list--container'}>
        {checkoutData.DiscountCodes.map((discountCode) => <div
            className={'cart-discount-code-list--item'}
            key={discountCode.code}>
            <div
                className={'cart-discount-code-list--info'}>
                <span>{discountCode.Discount.title}</span>
            </div>
            <AiOutlineClose
                className={'cart-item--remove-button'}
                onClick={handleDiscountCodeRemoval(discountCode)} />
        </div>)}
    </div>;
};

CartDiscountCodeList.defaultProps = {
    onRemoveDiscountCodeFailure: () => {},
    onRemoveDiscountCodeSuccess: () => {},
};

CartDiscountCodeList.propTypes = {
    onRemoveDiscountCodeFailure: func,
    onRemoveDiscountCodeSuccess: func,
};

export default CartDiscountCodeList;